import {
    getPermissionReshte,
    getEmtiazDetails,
    getPermissionHistory,
} from "@/api/tadris-permission";
export default {
    state: {
        reshte: [],
        emtiazDetails: [],
        history: [],
    },

    mutations: {
        SET_PERMISSION_RESHTE: (state, data) => {
            state.reshte = data;
        },
        SET_EMTIAZ_DETAILS: (state, data) => {
            state.emtiazDetails = data;
        },

        SET_PERMISSION_HISTORY: (state, data) => {
            state.history = data;
        },
        // SET_LAST_KHOROOJ: (state, data) => {
        //   state.last = data
        // }
    },

    actions: {
        getPermissionReshte({ commit }) {
            commit("SET_TABLE_TEXT", true);
            return new Promise((resolve, reject) => {
                getPermissionReshte()
                    .then((response) => {
                        if (!response.data) {
                            reject("error");
                        }
                        const data = response.data;;
                        commit("SET_PERMISSION_RESHTE", data);
                        commit("SET_TABLE_TEXT", false);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getEmtiazDetails({ commit }, formSerial) {
            return new Promise((resolve, reject) => {
                commit("SET_TABLE_TEXT", true);
                getEmtiazDetails(formSerial)
                    .then((response) => {
                        if (!response.data) {
                            reject("error");
                        }
                        const data = response.data;;
                        commit("SET_EMTIAZ_DETAILS", data);
                        commit("SET_TABLE_TEXT", false);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getPermissionHistory({ commit }) {
            commit("SET_TABLE_TEXT", true);
            return new Promise((resolve, reject) => {
                getPermissionHistory()
                    .then((response) => {
                        if (!response.data) {
                            reject("error");
                        }
                        const data = response.data;;
                        commit("SET_PERMISSION_HISTORY", data);
                        commit("SET_TABLE_TEXT", false);

                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};